module.exports = __webpack_public_path__ + "static/media/voiture.e96ca713.png";